import { SVGProps, Ref, forwardRef } from 'react';

export const IndexGrayscaleSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 15.146c3.866 0 7-3.167 7-7.073S11.866 1 8 1 1 4.167 1 8.073s3.134 7.073 7 7.073"
                    stroke="#919191"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.667 5.95c.129 0 .233.106.233.237 0 .13-.104.235-.233.235a.235.235 0 0 1-.234-.235c0-.13.105-.236.234-.236"
                    stroke="#919191"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.333 5.95c.13 0 .234.106.234.237 0 .13-.105.235-.234.235a.235.235 0 0 1-.233-.235c0-.13.105-.236.233-.236"
                    stroke="#919191"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.763 9.959A4.2 4.2 0 0 1 8 12.319a4.2 4.2 0 0 1-3.765-2.36"
                    stroke="#919191"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </g>
    </svg>
));
IndexGrayscaleSize16Glyph.displayName = 'IndexGrayscaleSize16Glyph';
